var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyLookalike(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 12C9.65685 12 11 10.6569 11 9C11 7.34315 9.65685 6 8 6C6.34315 6 5 7.34315 5 9C5 10.6569 6.34315 12 8 12Z",
    fill: "#A3B0C2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99978 13.25C6.04592 13.25 4.57528 13.7717 3.50604 14.5265C3.0038 14.881 2.66603 15.3459 2.55478 15.8859C2.4443 16.4222 2.57664 16.9393 2.83818 17.3639C3.35059 18.1957 4.38944 18.75 5.54117 18.75H10.4584C11.6101 18.75 12.649 18.1957 13.1614 17.3639C13.4229 16.9393 13.5553 16.4222 13.4448 15.8859C13.3335 15.3459 12.9958 14.881 12.4935 14.5265C11.4243 13.7717 9.95365 13.25 7.99978 13.25Z",
    fill: "#A3B0C2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 10.5C16.8284 10.5 17.5 9.82843 17.5 9C17.5 8.17157 16.8284 7.5 16 7.5C15.1716 7.5 14.5 8.17157 14.5 9C14.5 9.82843 15.1716 10.5 16 10.5ZM16 12C17.6569 12 19 10.6569 19 9C19 7.34315 17.6569 6 16 6C14.3431 6 13 7.34315 13 9C13 10.6569 14.3431 12 16 12Z",
    fill: "#A3B0C2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.25 14C15.25 13.5858 15.5858 13.25 16 13.25C17.9539 13.25 19.4245 13.7717 20.4937 14.5265C20.996 14.881 21.3338 15.3459 21.445 15.8859C21.5555 16.4222 21.4231 16.9393 21.1616 17.3639C20.6492 18.1957 19.6103 18.75 18.4586 18.75H16C15.5858 18.75 15.25 18.4142 15.25 18C15.25 17.5858 15.5858 17.25 16 17.25H18.4586C19.1607 17.25 19.6804 16.9084 19.8845 16.5772C19.9812 16.4202 19.9965 16.2889 19.9759 16.1886C19.956 16.0919 19.8837 15.9319 19.6287 15.7519C18.8368 15.1929 17.6751 14.75 16 14.75C15.5858 14.75 15.25 14.4142 15.25 14Z",
    fill: "#A3B0C2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyLookalike);
export default __webpack_public_path__ + "static/media/empty-lookalike.dc6d2d6b5d66779c2d39eb6f6525d1db.svg";
export { ForwardRef as ReactComponent };